import React, { ChangeEvent } from "react";
import styled from "styled-components";
import { transparentize } from "@glossy";
import { RADIUS_SMALL } from "@glossy/radii";
import { dominant, form, message } from "@glossy/theme";
import { Variant } from "@ui-kit/button";
import Icon from "@ui-kit/icon";
import { Glyph } from "@ui-kit/icon/glyphs";

const Root = styled.div`
  position: relative;
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 8px;
  right: 6px;
  color: ${form};
  pointer-events: none;
`;

const Textarea = styled.textarea<{
  minHeight: number;
  variant?: Variant;
  error?: boolean;
}>`
  height: auto;
  width: 100%;
  padding: 12px;
  min-height: ${(props) => props.minHeight}px;
  color: ${(props) =>
    props.error ? message(props, "error") : form(props, "primary")};
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-radius: ${RADIUS_SMALL};
  border-color: ${(props) =>
    props.error
      ? message(props, "error")
      : props.variant === "primary"
      ? "transparent"
      : transparentize(0.5, form(props, "primary"))};
  font-size: 12px;
  font-weight: bold;
  background-color: ${(props) =>
    props.variant === "primary"
      ? transparentize(0.85, form(props, "primary"))
      : "transparent"};
  :hover {
    border-color: ${(props) =>
      props.variant === "primary" ? "transparent" : form};
  }
  :focus {
    border-color: ${(props) =>
      props.variant === "primary" ? "transparent" : dominant};
  }
  ::placeholder {
    font-style: italic;
    color: ${(props) => transparentize(0.7, form(props, "primary"))};
  }
`;

interface IProps {
  content: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  minHeight?: number;
  error?: boolean;
  className?: string;
  placeholder?: string;
  icon?: Glyph;
  variant?: Variant;
}

const KomonFormTextarea = ({
  content,
  variant,
  error,
  onChange,
  minHeight = 150,
  className,
  placeholder,
  icon,
}: IProps) => (
  <Root className={className}>
    {!!icon && <StyledIcon glyph={icon} />}
    <Textarea
      variant={variant}
      minHeight={minHeight}
      value={content}
      placeholder={placeholder}
      onChange={onChange}
      error={error}
    />
  </Root>
);

export default KomonFormTextarea;
